import { render, staticRenderFns } from "./selectCourtXx.vue?vue&type=template&id=330bf896&scoped=true&"
import script from "./selectCourtXx.vue?vue&type=script&lang=js&"
export * from "./selectCourtXx.vue?vue&type=script&lang=js&"
import style0 from "./selectCourtXx.vue?vue&type=style&index=0&id=330bf896&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330bf896",
  null
  
)

export default component.exports